const modalActionTypes = {
  SHOW_MODAL: "SHOW_MODAL",
  HIDE_MODAL: "HIDE_MODAL",
  SHOW_WITHDRAWAL_MODAL: "SHOW_WITHDRAWAL_MODAL",
  HIDE_WITHDRAWAL_MODAL: "HIDE_WITHDRAWAL_MODAL",
  SHOW_INVEST_MODAL: "SHOW_INVEST_MODAL",
  HIDE_INVEST_MODAL: "SHOW_INVEST_MODAL",
};
export default modalActionTypes;
